/* eslint-disable import/prefer-default-export */
export const PAGE_TYPE = "HelpAFriend";
export const SHARE_NOW_HERO_GTM = ["Hero", "clicked", "Share_now"];
export const SHARE_NOW_HERO_MP = "website_landing_page_referral_lp_hero:share_now";

export const SHARE_NOW_HELP_A_FRIEND_GTM = ["HelpAFriend", "clicked", "Share_now"];
export const SHARE_NOW_HELP_A_FRIEND_MP = "website_landing_page_referral_lp_help_a_friend:share_now";

export const SHARE_NOW_CUSTOMERS_SAY_GTM = ["CustomersSay", "clicked", "Share_now"];
export const SHARE_NOW_CUSTOMERS_SAY_MP = "website_landing_page_referral_lp_customers_say:share_now";

export const SHARE_NOW_BOTTOM_BAR_GTM = ["BottomBar", "clicked", "Share_now"];
export const SHARE_NOW_BOTTOM_BAR_MP = "website_landing_page_referral_lp_bottom_bar:share_now";

export const MODAL_GENERATE_LINK_GTM = ["Modal", "clicked", "Generate_link"];
export const MODAL_GENERATE_LINK_MP = "website_landing_page_referral_lp_modal:generate_link";

export const MODAL_REGISTER_SUCCESS_GTM = {
  event: "registeredToReferral",
  status: "success",
};
export const MODAL_REGISTER_SUCCESS_MP = "website_landing_page_referral_lp_modal:register_success";

export const MODAL_REGISTER_ERROR_GTM = {
  event: "registeredToReferral",
  status: "error",
};
export const MODAL_REGISTER_ERROR_MP = "website_landing_page_referral_lp_modal:register_error";

export const MODAL_COPY_LINK_GTM = ["Modal", "clicked", "Copy_link"];
export const MODAL_COPY_LINK_MP = "website_landing_page_referral_lp_modal:copy_link";

export const MODAL_CLOSE_GTM = ["Modal", "clicked", "Close"];
export const MODAL_CLOSE_MP = "website_landing_page_referral_lp_modal:close";
